// @ts-nocheck
import React from "react";
import style from "./largeToggleSwitch.module.scss";

interface SwitchProps {
  /**
   * Switch state
   */
  active?: boolean;
  setActive: (active: boolean) => void;
  disabled?: boolean;
  propHandle?: (e: React.ChangeEvent<HTMLInputElement>) => void | null;
  customHandle?: (active: boolean) => void;
}

export const LargeSwitch: React.VFC<SwitchProps> = ({
  active,
  setActive,
  disabled,
  propHandle,
  customHandle,
  ...props
}: SwitchProps): JSX.Element => {
  const handleToggle = () => {
    setActive(!active);
    customHandle?.(!active);
  };

  return (
    <label className={style.switch} data-testid="large-switch-label" id="test-large-switch">
      <input
        type="checkbox"
        checked={active}
        onChange={() => {
          handleToggle();
        }}
        disabled={disabled}
        data-testid="large-switch-toggle"
      />
      <div className={style.movingArea}>
        <div className={style.switchOn} />
        <div className={style.switchOff} />
      </div>
      <span className={style.switchButton}></span>
    </label>
  );
};
